export default __webpack_public_path__ + "static/image-153-5a9196fd8270dc2a48810f79d7941224.png";